import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { PersonTypeService } from "../report-services/person-type.service";
import { ReportService } from "../report.service";
import { UserService } from "../../../shared";

@Component({
	selector: "app-staff-portal-users",
	templateUrl: "./staff-portal-users.component.html",
	styleUrls: ["./staff-portal-users.component.css"],
})
export class StaffPortalUsersComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private persontypeService: PersonTypeService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		PersonTypeID: 0,
		IsRegisteredID: 1,
		SortBy: "FirstName",
		SortDirection: "ASC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	PersonTypeList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	IsRegisteredList = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Already Registered",
		},
		{
			ID: 0,
			Desc: "Not Registered",
		},
	];

	SortByList = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Email",
			Desc: "Email",
		},
		{
			ID: "StaffID",
			Desc: "Staff ID",
		},
		{
			ID: "PersonType",
			Desc: "Staff Type",
		},
		{
			ID: "Language",
			Desc: "Language",
		},
		{
			ID: "School",
			Desc: "School",
		},
	];

	SortDirectionList = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	subscription: any;
	ReportID: number = 471;

	SchoolSelectShowAllText: string = "All Schools";

	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadPersonTypeList();
		this.loadLogolist();
	}

	private loadPersonTypeList() {
		this.report.PersonTypeID = 0;
		var result = this.persontypeService.loadPERSONTYPEList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PersonTypeList = response;

				this.report.PersonTypeID = this.PersonTypeList[0].PersonTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: PersonTypeID
		strParam += "," + this.report.PersonTypeID + "|PersonTypeID";

		//Parameter 3: IsRegistered
		strParam += "," + this.report.IsRegisteredID + "|IsRegistered";

		//Parameter 4: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 5: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 6: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
